module.exports = __webpack_public_path__ + "img/laddercontrol4.c6d4600d.png";